<template>
  <div id="tryoutgroup-form">
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>
        <router-link :to="{path: '/bimbel'}">Paket Bimbel</router-link>
      </li>
      <li class="active">Tambah Paket Bimbel</li>
    </ol>
    <!-- begin page-header -->
    <h1 class="page-header">Tambah Paket Bimbel</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Form Paket Bimbel</h4>
          </div>
          <div class="panel-body">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Nama Paket*</label>
                  <div class="col-md-8 col-xs-12">
                      <input type="text" class="form-control" v-model="name">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Deskripsi*</label>
                  <div class="col-md-8 col-xs-12">
                      <textarea v-model="description" style="min-width:350px; border:solid lightgray 1px"></textarea>
                  </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label">Jenjang *</label>
                    <div class="col-md-2 col-xs-2">
                        <select class="form-control" v-model="jenjang" @change="resetKelas()">
                            <option v-for="(item,index) in jenjangList" v-bind:key="index">{{item}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group" v-if="jenjang">
                    <label class="col-md-2 control-label">Kelas *</label>
                    <div class="col-md-2 col-xs-2">
                      <div v-if="jenjang === 'SD'">
                        <select class="form-control" v-model="kelas">
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                        </select>
                      </div>
                      <div v-if="jenjang === 'SMP'">
                        <select class="form-control" v-model="kelas">
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                        </select>
                      </div>
                      <div v-if="jenjang === 'SMA'">
                        <select class="form-control" v-model="kelas">
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                        </select>
                      </div>
                    </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">URL Gambar</label>
                  <div class="col-md-8 col-xs-12">
                      <!-- <input type="text" class="form-control" v-model="picture_url"> -->
                      <textarea v-model="picture_url" style="min-width:450px; border:solid lightgray 1px"></textarea>
                  </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label">Kurikulum*</label>
                    <div class="col-md-2 col-xs-2">
                        <select class="form-control" v-model="kurikulum">
                            <option v-for="item in kurikulumList" v-bind:key="item.id" :value="item.id">{{item.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Start Date*</label>
                  <transition name="fade">
                    <div class="col-md-4 col-xs-12">
                      <div class="input-group">
                        <input id="startDate" v-model="start_date" type="text" class="form-control datepicker" placeholder="Tanggal" name="start_date" readonly>
                        <span class="input-group-btn">
                          <button class="btn btn-success" type="button">
                            <i class="fa fa-calendar"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </transition>
                  <div class="col-md-4 col-xs-12">
                    <div class="input-group clockpicker">
                      <input id="startTime" v-model="start_time" type="text" class="form-control" placeholder="Jam : Menit" name="start_time" readonly>
                      <span class="input-group-btn">
                        <button class="btn btn-success" type="button">
                          <i class="fa fa-clock-o"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">End Date*</label>
                  <transition name="fade">
                    <div class="col-md-4 col-xs-12">
                      <div class="input-group">
                        <input id="endDate" v-model="end_date" type="text" class="form-control datepicker" placeholder="Tanggal" name="start_date" readonly>
                        <span class="input-group-btn">
                          <button class="btn btn-success" type="button">
                            <i class="fa fa-calendar"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </transition>
                  <div class="col-md-4 col-xs-12">
                    <div class="input-group clockpicker">
                      <input id="endTime" v-model="end_time" type="text" class="form-control" placeholder="Jam : Menit" name="end_time" readonly>
                      <span class="input-group-btn">
                        <button class="btn btn-success" type="button">
                          <i class="fa fa-clock-o"></i>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Mata Pelajaran*</label>
                  <div class="col-md-10 col-xs-12" style="display:flex; flex-flow: column;">
                    <button type="button" class="btn btn-success pull-left mb-3" style="width:100px;" @click="openMapel()">Pilih</button>
                    <div style="width: 100%; position:relative;">
                      <div v-for="(item,index) in selectedMapel" v-bind:key="index" style="border:1px solid lightgray; padding: 5px;width: fit-content; margin-bottom: 5px;">
                        {{ item.data[1] }}
                        &nbsp; <i class="fa fa-close" style="cursor:pointer;" @click="deleteMapel(index)"></i>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </form>
            <hr />
            <div class="pull-right">
                <button v-if="!$route.params.id" type="button" class="btn btn-success pull-right" @click="saveData()">Simpan</button>
                <button v-else type="button" class="btn btn-success pull-right" @click="editData()">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="mapelmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Pilih Paket Mata Pelajaran</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="list-group">
              <a v-for="(item,index) in listMapelPackage" v-bind:key="index" @click="selectMapel(item)" data-dismiss="modal" aria-label="Close" class="list-group-item list-group-item-action">
                {{ item.name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-mapelchooser :params="{grade: '', status: 'PUBLISHED', type: '', variant: ''}"
    ref="mapelChooser" v-on:dblClicked="mapelSelected($event)"></app-mapelchooser>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<style>
  .modal-body {
    overflow: auto;
    margin: 0px;
  }
</style>
<script>
import MapelChooser from './MapelChooser'
import Spinner from '@/components/plugins/Spinner'
import Modal from '@/components/plugins/Modal'
import moment from 'moment'
import axios from 'axios'
import BimbelService from '@/services/bimbel.js'

export default {
  name: 'tryoutgroup-form',
  components: {
    'app-spinner': Spinner,
    'app-modal': Modal,
    'app-mapelchooser': MapelChooser
  },
  data: function() {
    return {
      isLoading: false,
      errors: [],
      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1,2,3,4,5,6,7,8,9,10,11,12],
      mapelList: JSON.parse(localStorage.getItem('mapels')),
      kurikulumList: JSON.parse(localStorage.getItem('kurikulum')),
      jenjang: null,
      start_date: null,
      start_time: null,
      end_date: null,
      end_time: null,
      listMapelPackage: [],
      // selectedMapel: []  
    }
  },
  created(){
  },
  watch: {
    
  },
  computed: {
    kelas: {
      get: function() {
        return this.$store.state.bimbel.bimbel_kelas
      },
      set: function(value) {
        this.$store.commit('bimbel_set_bimbel_kelas', value)
      }
    },
    name: {
      get: function() {
        return this.$store.state.bimbel.bimbel_name
      },
      set: function(value) {
        this.$store.commit('bimbel_set_bimbel_name', value)
      }
    },
    kurikulum: {
      get: function() {
        return this.$store.state.bimbel.bimbel_kurikulum
      },
      set: function(value) {
        this.$store.commit('bimbel_set_bimbel_kurikulum', value)
      }
    },
    selectedMapel: {
      get: function() {
        return this.$store.state.bimbel.bimbel_mapel
      },
      set: function(value) {
        this.$store.commit('bimbel_set_bimbel_mapel', value)
      }
    },
    start_date: {
      get: function() {
        return this.$store.state.bimbel.bimbel_start
      },
      set: function(value) {
        this.$store.commit('bimbel_set_bimbel_start', value)
      }
    },
    description: {
      get: function() {
        return this.$store.state.bimbel.bimbel_description
      },
      set: function(value) {
        this.$store.commit('bimbel_set_bimbel_description', value)
      }
    },
    picture_url: {
      get: function() {
        return this.$store.state.bimbel.picture_url
      },
      set: function(value) {
        this.$store.commit('bimbel_set_picture_url', value)
      }
    },
    end_date: {
      get: function() {
        return this.$store.state.bimbel.bimbel_end
      },
      set: function(value) {
        this.$store.commit('bimbel_set_bimbel_end', value)
      }
    },
  },
  methods: {
    resetKelas() {
      this.kelas = []
    },
    openMapel() {
      this.$refs.mapelChooser.openGroupModal()
    },
    getPaketMapel() {
      var context = this
      BimbelService.getListPackage( (response) => {
          if (response.success) {
            context.listMapelPackage = response.data
          } else {
            return
          }
        })
    },
    mapelSelected(item) { 
      var found = this.selectedMapel.find(function(element) {
        return element.id == item.id
      })
      if(!found) this.selectedMapel.push(item)
    },
    deleteMapel(index){
      this.selectedMapel.splice(index,1)
    },
    validateForm: function() {
      this.errors = []
      if (this.name == '') this.errors.push('Nama wajib diisi')
      if (this.selectedMapel.length < 1) this.errors.push('Mapel wajib diisi')
      if (this.kurikulum == '') this.errors.push('Kurikulum Pelajaran wajib diisi')
      if (this.jenjang == null) this.errors.push('Jenjang wajib diisi')
      if (this.kelas == '') this.errors.push('Kelas wajib diisi')
      if (this.description == '') this.errors.push('Deskripsi wajib diisi')
      if (this.start_date == null) this.errors.push('Start Date wajib diisi')
      if (this.end_date == null) this.errors.push('End Date wajib diisi')
      if (this.start_time == null) this.errors.push('Start Time wajib diisi')
      if (this.end_time == null) this.errors.push('End Time wajib diisi')
      return this.errors.length == 0
    },
    saveData: function() {
      if (!this.validateForm()) {
        return
      }
        var mapelid = []
        for(var i = 0; i < this.selectedMapel.length; i++){
          mapelid.push(this.selectedMapel[i].id)
        }
        this.isLoading = true
        var context = this
        var body = {
                  name : this.name,
                  description : this.description,
                  grade : this.kelas,
                  jenjang: this.jenjang,
                  start_date : this.start_date + ' ' + this.start_time,
                  end_date : this.end_date + ' ' + this.end_time,
                  curriculum_id : this.kurikulum,
                  block_packages : mapelid,
                  picture: this.picture_url
                }
        BimbelService.addBimbel( body, function(result) {
          context.isLoading = false
          context.$store.commit('bimbel_reset', result.data)
          context.$router.push({path: '/paket-bimbel'})
        })
    },
    editData: function() {
      if (!this.validateForm()) {
        return
      }
        var mapelid = []
        for(var i = 0; i < this.selectedMapel.length; i++){
          mapelid.push(this.selectedMapel[i].id)
        }
        this.isLoading = true
        var context = this
        var body = {
                  name : this.name,
                  description : this.description,
                  grade : this.kelas,
                  jenjang: this.jenjang,
                  start_date : this.start_date + ' ' + this.start_time,
                  end_date : this.end_date + ' ' + this.end_time,
                  curriculum_id : this.kurikulum,
                  block_packages : mapelid,
                  picture: this.picture_url
                }
        BimbelService.editBimbel([body, this.$route.params.id], function(result) {
          context.isLoading = false
          context.$store.commit('bimbel_reset', result.data)
          context.$router.push({path: '/paket-bimbel'})
        })  
    },
  },
  mounted: function () {
    var context = this
    DatepickerPlugin.init("#startDate", function(value) {
      context.start_date = moment(value, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      )
    })

    DatepickerPlugin.init("#endDate", function(value) {
      context.end_date = moment(value, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      )
    })

    ClockpickerPlugin.init("#startTime", function(value) {
      context.start_time = value + ":00";
    })

    ClockpickerPlugin.init("#endTime", function(value) {
      context.end_time = value + ":00";
    })
    if(this.$route.params.id){
     var context = this
    //  this.changeUrl = false
     BimbelService.getbimbelDetailById( this.$route.params.id, function(result) {
        var gradeWrap = []
        context.name = result.data.name
        context.description = result.data.description
        context.jenjang = result.data.grade < 7 ? 'SD' : result.data.grade < 10 ? 'SMP' : result.data.grade > 9 ? 'SMA' : 'SMA'
        context.kelas = result.data.grade
        context.kurikulum = result.data.curriculum.id
        context.start_date = moment.utc(result.data.start_date).format("YYYY-MM-DD") //parse string
        context.end_date = moment.utc(result.data.end_date).format("YYYY-MM-DD") //parse string
        context.start_time = moment.utc(result.data.start_date).format("HH:mm:ss") //parse string
        context.end_time = moment.utc(result.data.end_date).format("HH:mm:ss") //parse string
        context.selectedMapel = []
        context.picture_url = result.data.picture
        var block = result.data.block_packages

        for(var i = 0; i < block.length; i++){
          var wrapper = {
            id: block[i].id,
            data: [
              block[i].mapel_name,
              block[i].name,
              block[i].semester
            ]
          }
          context.selectedMapel.push(wrapper)
        }

      })
    } else {
      this.$store.commit('bimbel_reset', '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?33f52ab6